const postEndStreamResponse = (response) => {
  return response?.data;
};

export default postEndStreamResponse;
